import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { withdrawalDisabledReasonLabel } from '@/lib/withdrawal/disabledReasonLabels';
import * as PM from '@/messages/payment';
import type { OrderLineWithdrawalCaptionModel } from '@/views/withdrawal/orderLineWithdrawalCaption';

export type OrderLineWithdrawalCaptionProps = {
  model: OrderLineWithdrawalCaptionModel;
};

export const OrderLineWithdrawalCaption: FC<
  OrderLineWithdrawalCaptionProps
> = ({ model }) => {
  const { formatMessage } = useIntl();

  if (model.variant === 'hidden') {
    return null;
  }

  if (model.variant === 'eligible') {
    return (
      <Typography
        color='defaultAdd4'
        data-testid='OrderDetailsViewOrderLineWithdrawalEligible'
        scale='p3'
      >
        {formatMessage(PM.paymentMessages.withdrawalLineEligible)}
      </Typography>
    );
  }

  const line = model.eligibilityLine;

  return (
    <Typography
      color='defaultAdd4'
      data-testid='OrderDetailsViewOrderLineWithdrawalIneligible'
      scale='p3'
    >
      {line?.disabledReasonCode
        ? formatMessage(PM.paymentMessages.withdrawalNotEligibleReason, {
            reason: withdrawalDisabledReasonLabel(
              line.disabledReasonCode,
              formatMessage,
            ),
          })
        : formatMessage(PM.paymentMessages.withdrawalNotEligible)}
    </Typography>
  );
};
